var Agitavit;
(function (Agitavit) {
    /**
     * Represents an event dispatcher.
     */
    var EventDispatcher = /** @class */ (function () {
        function EventDispatcher() {
            this.listeners = [];
        }
        /**
         * Dispatches event to event subscribers.
         * @param sender - Sender of the event.
         * @param args - Arguments of the event.
         */
        EventDispatcher.prototype.dispatch = function (sender, args) {
            this.listeners.forEach(function (listener) { return listener(sender, args); });
        };
        /**
         * Subscribes event listener to event.
         * @param listener - Event listener to be subscribed to event.
         */
        EventDispatcher.prototype.subscribe = function (listener) {
            this.listeners.push(listener);
        };
        /**
         * Unsubscribes event listener from event.
         * @param listener - Event listener to be unsubscribed from event.
         */
        EventDispatcher.prototype.unsubscribe = function (listener) {
            var index = this.listeners.indexOf(listener);
            if (index !== -1) {
                this.listeners.splice(index, 1);
            }
        };
        /**
         * Clears all event listeners from event.
         * @param listener - Event listener to be unsubscribed from event.
         */
        EventDispatcher.prototype.clear = function () {
            this.listeners = [];
        };
        /**
         * Returns current event dispacher as ISubscribable interface. To prevent consumers from calling dispatch on it.
         */
        EventDispatcher.prototype.asEvent = function () {
            return this;
        };
        return EventDispatcher;
    }());
    Agitavit.EventDispatcher = EventDispatcher;
})(Agitavit || (Agitavit = {}));
//# sourceMappingURL=event-dispatcher.js.map